import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/redpack.png'
import _imports_1 from '@/assets/image/distribution_list_with_money.png'
import _imports_2 from '@/assets/image/distribution_list_without_money.png'


const _withScopeId = n => (_pushScopeId("data-v-08825ffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"color":"red"} }
const _hoisted_2 = { class: "red-pack" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "red pack",
  style: {"width":"80%"}
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "demo-img",
  src: _imports_1,
  alt: "",
  width: "100%"
}
const _hoisted_6 = {
  key: 2,
  class: "demo-img",
  src: _imports_2,
  alt: "",
  width: "100%"
}

import FrameContentPreview from "@/app/editor/views/FrameContentPreview.vue";
import {editor} from "@/app/editor";
import {RecommendModuleV1} from "@/app/editor/modules/recommend/v1/recommend_v1";
import GiftPreview from "@/app/editor/views/GiftPreview.vue";
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendPreview',
  props: {
    index: {}
  },
  setup(__props: any) {


const props = __props
const recommend = editor.activity?.modules[props.index] as RecommendModuleV1

const redPack = computed(() => Math.floor(recommend.config.distribution_rule.percents[0] * (editor.activity?.status.sell_price ?? 0) / 100))

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(`section_${_ctx.index}`)
    }, null, 2),
    (_unref(recommend).config.distribution_rule.enable)
      ? (_openBlock(), _createBlock(FrameContentPreview, {
          key: 0,
          title: "推荐有红包"
        }, {
          default: _withCtx(() => [
            (_unref(recommend).config.distribution_rule.enable)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_a_typography_title, { level: 5 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(recommend).config.distribution_rule.props.require == 'pay' ? '报名' : '') + "分享活动链接给身边朋友，每报名一位，直接得 ", 1),
                      _createElementVNode("span", _hoisted_1, _toDisplayString(redPack.value) + "元红包秒到账", 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("span", null, _toDisplayString(redPack.value), 1)
                  ]),
                  _createVNode(_component_a_typography_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" 点击右上角“生成海报”图标"),
                      _hoisted_4,
                      _createTextVNode("按要求操作，有机会获取" + _toDisplayString(redPack.value) + "元 ", 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (_unref(recommend).config.distribution_rule.props.show_list=='sum')
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (_unref(recommend).config.distribution_rule.props.show_list=='count')
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(recommend).config.gift_rules.length>0)
      ? (_openBlock(), _createBlock(FrameContentPreview, {
          key: 1,
          title: "推荐有礼"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommend).config.gift_rules, (r) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: r.freshman_count
              }, [
                _createVNode(_component_a_typography_title, {
                  level: 4,
                  style: {"color":"red","margin":"10px 0 0 0"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 推荐 " + _toDisplayString(r.freshman_count) + " 名 " + _toDisplayString(_unref(editor).activity.data.tags.find(t => t.startsWith('t_se')) ? '新生' : '新客') + " 得 ", 1)
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.gifts, (g) => {
                  return (_openBlock(), _createBlock(GiftPreview, {
                    key: g.gift_id,
                    gift: g
                  }, null, 8, ["gift"]))
                }), 128))
              ], 64))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})